// Mock data for Masigo Korean Restaurant

export const restaurantInfo = {
  name: "Masigo",
  tagline: "Authentic Korean Dining in Chapel Market",
  subtitle: "Warm flavours. Generous portions. True Korean tradition.",
  address: {
    street: "29 Chapel Market",
    city: "London N1 9EN",
    country: "United Kingdom"
  },
  phone: "+44 20 7916 3212",
  displayPhone: "020 7837 2833",
  rating: 4.6,
  reviewCount: 680,
  priceRange: "£20–30 per person"
};

export const openingHours = {
  monday: "Closed",
  tuesday: "12:00 PM – 3:00 PM, 5:30 PM – 10:00 PM",
  wednesday: "12:00 PM – 3:00 PM, 5:30 PM – 10:00 PM",
  thursday: "12:00 PM – 3:00 PM, 5:30 PM – 10:00 PM",
  friday: "12:00 PM – 3:00 PM, 5:30 PM – 10:00 PM",
  saturday: "12:00 PM – 10:00 PM",
  sunday: "12:00 PM – 9:00 PM"
};

export const signatureDishes = [
  {
    id: 1,
    name: "Korean Fried Chicken",
    description: "Crispy double-fried chicken glazed with sweet and spicy yangnyeom sauce, topped with sesame seeds",
    price: "£12.50",
    image: "https://images.unsplash.com/photo-1709164632728-8a943456dd0a"
  },
  {
    id: 2,
    name: "Dolsot Bibimbap",
    description: "Hot stone bowl with rice, assorted vegetables, beef, and fried egg with gochujang sauce",
    price: "£13.00",
    image: "https://images.unsplash.com/photo-1718777791239-c473e9ce7376"
  },
  {
    id: 3,
    name: "Kimchi Jjigae",
    description: "Traditional fermented kimchi stew with pork, tofu, and vegetables in a spicy broth",
    price: "£11.00",
    image: "https://images.unsplash.com/photo-1760228865341-675704c22a5b"
  },
  {
    id: 4,
    name: "Seafood Pancake (Pajeon)",
    description: "Crispy Korean pancake loaded with fresh seafood, scallions, and served with soy dipping sauce",
    price: "£9.50",
    image: "https://images.unsplash.com/photo-1616627077891-a4780e730b7e"
  },
  {
    id: 5,
    name: "Dak Bulgogi",
    description: "Marinated chicken grilled with Korean spices, served with rice and banchan",
    price: "£12.00",
    image: "https://images.unsplash.com/photo-1564836235910-c3055ca0f912"
  },
  {
    id: 6,
    name: "Japchae",
    description: "Stir-fried glass noodles with vegetables and beef in a sweet soy sauce",
    price: "£10.50",
    image: "https://images.unsplash.com/photo-1583032015879-e5022cb87c3b"
  }
];

export const reviews = [
  {
    id: 1,
    text: "Authentic Korean food ran by Koreans. Everything was absolutely amazing.",
    author: "Sarah M."
  },
  {
    id: 2,
    text: "Portions are generous and incredible value for money.",
    author: "James L."
  },
  {
    id: 3,
    text: "The Korean fried chicken was outstanding.",
    author: "Emma K."
  },
  {
    id: 4,
    text: "No discretionary charge — refreshing and honest.",
    author: "Michael T."
  }
];

export const diningFeatures = [
  {
    id: 1,
    title: "Lunch & Dinner Service",
    description: "Open Tuesday to Sunday"
  },
  {
    id: 2,
    title: "Cosy & Trendy Atmosphere",
    description: "Perfect for casual dining"
  },
  {
    id: 3,
    title: "Ideal for Groups",
    description: "Popular with students & locals"
  },
  {
    id: 4,
    title: "Vegetarian & Meat Options",
    description: "Diverse menu selection"
  },
  {
    id: 5,
    title: "Authentic Korean Cuisine",
    description: "Traditional recipes & flavors"
  }
];

export const aboutText = `Masigo brings authentic Korean cuisine to the heart of London's Chapel Market. Known for its generous portions, traditional flavours and warm atmosphere, the restaurant has become a favourite for both casual lunches and hearty dinners.

With a 4.6-star rating and over 680 reviews, Masigo delivers a true Korean dining experience — from crispy Yangnyeom chicken to comforting kimchi jjigae.`;
